import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";
import { NotificationsPanel } from "@/components/NotificationsPanel";
import { InstallPwaBanner } from "@/components/widgets/InstallPwaBanner";
import OfflineBanner from "@/components/widgets/OfflineBanner";

export const DashboardLayout = () => {
    const [notifOpen, setNotifOpen] = useState(false);
    const [unreadCount, setUnreadCount] = useState(undefined);
    const location = useLocation();

    return (
        <div className="min-h-screen relative">
            <OfflineBanner />
            {/* subtle ambient mesh on app background */}
            <div
                aria-hidden
                className="fixed inset-0 pointer-events-none -z-10"
                style={{
                    background:
                        "radial-gradient(at 8% 2%, rgba(232,169,106,0.18) 0%, transparent 40%)," +
                        "radial-gradient(at 92% 100%, rgba(200,121,65,0.12) 0%, transparent 45%)",
                }}
            />
            <Sidebar />
            <div style={{ marginLeft: "var(--sidebar-width)" }} className="min-h-screen flex flex-col">
                <TopBar
                    onOpenNotifications={() => setNotifOpen(true)}
                    unreadCount={unreadCount}
                />
                <main className="flex-1 px-8 py-8 max-w-[1480px] w-full mx-auto">
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={location.pathname}
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -6 }}
                            transition={{ duration: 0.28, ease: [0.4, 0, 0.2, 1] }}
                        >
                            <Outlet />
                        </motion.div>
                    </AnimatePresence>
                </main>
            </div>
            <NotificationsPanel
                open={notifOpen}
                onClose={() => setNotifOpen(false)}
                onUnreadChange={setUnreadCount}
            />
            <InstallPwaBanner />
        </div>
    );
};
